import { useMemo } from 'react';
import { useUserDetails } from './use-user-details';
export function useHasPermission(permission) {
    const { permissions } = useUserDetails();
    const hasPermission = useMemo(() => permissions.includes(permission), [permissions, permission]);
    return hasPermission;
}
